import { Icon, type IconProps } from './Icon';

/**
 * Trophy "Hits" cup (Figma hits.svg) — the Potential Hits affordance in the
 * modern pack header. Filled bowl + stroked stem/base/handles, all drawn in
 * `currentColor` so it stays themeable. The design's 50% opacity is applied
 * by the caller via an `opacity-50` class (not baked in), matching the Cards
 * icon it replaces. Native 25-unit grid, so the viewBox is overridden.
 */
export function Hits(props: IconProps) {
  return (
    <Icon viewBox="0 0 25 25" fill="none" strokeWidth={1.85185} {...props}>
      {/* Cup bowl — filled + same-colour outline. */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        strokeWidth={1.38889}
        d="M13.5416 17.1872H11.4583C9.15725 17.1872 7.29163 15.3216 7.29163 13.0205V4.68717C7.29163 4.11217 7.75829 3.64551 8.33329 3.64551H16.6666C17.2416 3.64551 17.7083 4.11217 17.7083 4.68717V13.0205C17.7083 15.3216 15.8427 17.1872 13.5416 17.1872Z"
      />
      {/* Stem. */}
      <path d="M12.5 17.1875V21.3542" />
      {/* Base. */}
      <path d="M9.375 21.3538H15.625" />
      {/* Right handle. */}
      <path d="M17.7084 6.77051H20.8334C21.4084 6.77051 21.875 7.23717 21.875 7.81217V9.89551C21.875 11.6215 20.4761 13.0205 18.75 13.0205H17.7084" />
      {/* Left handle. */}
      <path d="M7.29167 6.77051H4.16667C3.59167 6.77051 3.125 7.23717 3.125 7.81217V9.89551C3.125 11.6215 4.52396 13.0205 6.25 13.0205H7.29167" />
    </Icon>
  );
}
